import * as React from 'react';
import { useLocalization } from '@progress/kendo-react-intl';
import { Button, DropDownButton } from '@progress/kendo-react-buttons';
import { addAbove, addBelow, addChild, addTask, messages } from '../../messages';
import { IconWrap } from '@progress/kendo-react-common';
import { plusIcon } from '@progress/kendo-svg-icons';
/** @hidden */
export var AddButton = React.forwardRef(function (props, _) {
    var localizationService = useLocalization();
    var localizeMessage = function (message) {
        return localizationService.toLanguageString(message, messages[message]);
    };
    var addTaskMessage = localizeMessage(addTask);
    var addChildMessage = localizeMessage(addChild);
    var addAboveMessage = localizeMessage(addAbove);
    var addBelowMessage = localizeMessage(addBelow);
    var handleItemClick = React.useCallback(function (event) {
        event.syntheticEvent.preventDefault();
        var direction = event.item && event.item.direction ? event.item.direction : 'none';
        if (props.onClick) {
            props.onClick({
                nativeEvent: event.nativeEvent,
                syntheticEvent: event.syntheticEvent,
                direction: direction
            });
        }
    }, [props.onClick]);
    var handleButtonClick = React.useCallback(function (syntheticEvent) {
        syntheticEvent.preventDefault();
        if (props.onClick) {
            props.onClick({
                nativeEvent: syntheticEvent && syntheticEvent.nativeEvent,
                syntheticEvent: syntheticEvent,
                direction: 'none'
            });
        }
    }, [props.onClick]);
    var buttonTitle = (React.createElement(React.Fragment, null,
        React.createElement(IconWrap, { name: "plus", icon: plusIcon }),
        addTaskMessage));
    return (!props.selectedTask ? (React.createElement(Button, { onClick: handleButtonClick }, buttonTitle)) : (React.createElement(DropDownButton, { className: "k-views-dropdown", onItemClick: handleItemClick, popupSettings: { popupClass: 'k-gantt-toolbar' }, textField: "title", items: [
            { title: addChildMessage, direction: 'child' },
            { title: addAboveMessage, direction: 'above' },
            { title: addBelowMessage, direction: 'below' }
        ], text: buttonTitle })));
});
AddButton.displayName = 'KendoReactGanttAddButton';
